@use "../../../../../../../styles/Constants.scss" as Constants;
@use "../../../../../../../styles/Colors.scss" as Colors;

.contact-dropdown {
	flex: 1;

	& [class^="react-select-container"] {
		display: flex;
		flex-direction: column;
	}

	& [class^="react-select-dropdown"] {
		position: static !important;
		z-index: auto;
	}

	.error-message {
		color: Colors.$col-red;
		margin-top: Constants.$val-spacing-xs;
		margin-left: 1px;
	}
}

.error-exists {
	& [class*="css-cnhab-control"] {
		border-style: solid;
		border-width: 1px;
		border-color: Colors.$color-red !important;
	}
}
